import { render, staticRenderFns } from "./invDataUp.vue?vue&type=template&id=a91e6a28"
import script from "./invDataUp.vue?vue&type=script&lang=js"
export * from "./invDataUp.vue?vue&type=script&lang=js"
import style0 from "./invDataUp.vue?vue&type=style&index=0&id=a91e6a28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports